import React from 'react'

// styles
import './Chip.css'

export default function Chip({ label }) {
    return (<div className='chip'>{ label }</div>)
}